// ハンバーガーメニュー
$(function () {
	$('.zdo_drawer_button').click(function () {
		$(this).toggleClass('active');
		$('.header_content').toggleClass('active');
		$('.zdo_drawer_bg').fadeToggle();
		$('nav').toggleClass('open');
	})
	$('.zdo_drawer_bg').click(function () {
		$(this).fadeOut();
		$('.header_content').toggleClass('active');
		$('.zdo_drawer_button').removeClass('active');
		$('nav').removeClass('open');
	});
	$('.zdo_drawer_nav li a').click(function () {
		$('.zdo_drawer_button').toggleClass('active');
		$('.header_content').toggleClass('active');
		$('.zdo_drawer_bg').fadeToggle();
		$('nav').toggleClass('open');
	})
})

// アコーディオン
$(function(){
	$(".accordionbox dt").on("click", function() {
		$(this).next().slideToggle("fast");	
		if ($(this).children(".accordion_icon").hasClass('active')) {			
			$(this).children(".accordion_icon").removeClass('active');				
		}
		else {
			$(this).children(".accordion_icon").addClass('active');			
		}			
	});
});